var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFreespinGold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#freespin-gold_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 26,
  x: 1,
  fill: "url(#freespin-gold_svg__b)",
  rx: 13
}), /*#__PURE__*/React.createElement("path", {
  fill: "#161639",
  d: "M7.281 19.17c-1.666-.003-2.805-.047-2.868-.112-.085-.086-.122-1.341-.111-2.466 0-.875.026-1.676.083-1.774.06-.102.243-.183.558-.241q.435-.083.721-.272c.185-.14.334-.312.443-.505.12-.229.187-.467.204-.7a1.68 1.68 0 0 0-.26-.973 1.5 1.5 0 0 0-.651-.566 2 2 0 0 0-.502-.15c-.286-.046-.449-.12-.51-.225-.056-.094-.083-.836-.086-1.669-.012-1.151.025-2.488.112-2.578.057-.057 1.827-.097 4.823-.107.82-.006 1.651-.006 2.453-.003h2.589c2.16-.002 4.223-.003 6.44 0 1.665.004 2.805.048 2.868.113.085.085.122 1.341.111 2.466 0 .875-.027 1.676-.083 1.774-.06.102-.243.182-.558.24q-.434.083-.722.273c-.184.14-.334.312-.443.505-.12.229-.186.467-.204.7-.016.321.065.657.26.973.152.245.374.434.652.565q.228.105.501.15c.286.047.45.12.511.226.055.094.083.835.085 1.669.013 1.15-.025 2.488-.111 2.578-.057.057-1.827.097-4.823.107-.82.005-1.652.006-2.453.003h-2.59c-2.159.002-4.223.003-6.439 0m10.07-7.73a.5.5 0 0 0-.3-.398q-.256-.127-.673-.07a1.3 1.3 0 0 0-.504.175q-.213.133-.213.34t.239.277.7.125l.554.06q.367.044.691.11.334.057.58.211.247.155.393.436.145.273.162.744a2.03 2.03 0 0 1-.76 1.632 2.9 2.9 0 0 1-.776.454 4 4 0 0 1-1.732.252 2.2 2.2 0 0 1-.81-.231 1.8 1.8 0 0 1-.64-.574q-.255-.386-.316-.98l1.553-.219q.085.36.4.47.325.11.752.05a2 2 0 0 0 .264-.055q.137-.037.248-.095a.6.6 0 0 0 .187-.165.38.38 0 0 0 .077-.243q0-.19-.162-.262-.153-.081-.444-.092l-.477-.037a7 7 0 0 1-.913-.121 2.2 2.2 0 0 1-.691-.248 1.24 1.24 0 0 1-.444-.48q-.162-.304-.162-.813v-.017q.034-.522.256-.898.222-.375.554-.638.375-.294.785-.429.418-.136.88-.2.382-.046.741.015.367.053.649.21.359.2.571.575.215.367.273.918zm-3.87-1.413v1.448l-2.917.41v1.111l2.406-.338v1.43l-2.406.338v2.111l-1.544.217v-6.1z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "freespin-gold_svg__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(0 26 -12.8908 0 13.89 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE600"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCA31E"
})), /*#__PURE__*/React.createElement("filter", {
  id: "freespin-gold_svg__a",
  width: 74,
  height: 74,
  x: -23,
  y: -24,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_8905_33617"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0156863 0 0 0 0 0.054902 0 0 0 0 0.164706 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_backgroundBlur_8905_33617",
  result: "effect2_dropShadow_8905_33617"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_8905_33617",
  result: "shape"
})))));
export default SvgFreespinGold;